export const TAG_DROPDOWN_VARIANTS = Object.freeze({
  // Default variant usually used in settings.
  DEFAULT: 'DEFAULT',
  // Variant used inside inbox
  INBOX: 'INBOX',
})
